/** Lab CreateEventCtrl body — competition must be vendor league id, not Postgres row uuid. */
export function buildEventCreatePayload(
  competition: Record<string, unknown>,
  name: string,
  openDate: string,
): Record<string, unknown> {
  const competitionId = competition.id ?? competition.betfairId ?? competition.competitionId
  return {
    name: name.trim(),
    competition: competitionId,
    openDate,
  }
}
